import styles from './SharingContainer.module.scss';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { getActiveSalon } from '../../../Auth/store/selectors';
import useWindowSize from '../../../../utils/useWindowSize';
import clx from 'classnames';
import TitleSectionBack from '../../../Common/TitleSectionBack';
import { ReactComponent as SharingIcon } from '../../../../assets/svg/icons/condividi.svg';
import { modalActions } from '../../../Modals/store';
import { toastActions } from 'Containers/Toasts/store';
import { Copy } from 'lucide-react';

const SharingContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const activeSalon = useSelector(getActiveSalon());

  const copyLinkToClickBoard = async (link) => {
    await navigator.clipboard.writeText(link);
    dispatch(
      toastActions.OPEN_TOAST.SUCCESS({
        type: 'success',
        props: { title: t('settings.sharingContainer.qrCode.successModal.header') },
      }),
    );
  };
  return (
    <div
      className={clx(styles.sharing_container, {
        [styles.sharing_container_mobile]: isMobile,
      })}
    >
      <div className={styles.header}>
        <TitleSectionBack
          title={t('settings.sharingContainer.title')}
          description={t('settings.sharingContainer.description')}
        />
      </div>
      <div className={styles.sharing_container_list}>
        <div className={styles.sharing_item}>
          <div className={styles.item_title}>{t('settings.sharingContainer.items.downloadQRCode')}</div>
          <button
            style={{ border: 'none', backgroundColor: 'transparent' }}
            onClick={() => {
              dispatch(
                modalActions.OPEN_MODAL.SUCCESS({
                  type: 'qrCodeModal',
                  props: { activeSalon },
                }),
              );
            }}
          >
            <SharingIcon />
          </button>
        </div>
        <div className={styles.sharing_item}>
          <div className={styles.item_title}>{t('settings.sharingContainer.items.shareSalonLink')}</div>
          <Copy
            className={styles.copy_icon}
            size={19}
            strokeWidth={1.5}
            onClick={() =>
              copyLinkToClickBoard(
                `https://application.zetabarber.it/barber/${activeSalon.username}`,
              )
            }
          />
        </div>
        {!(<div className={styles.sharing_item}>
          <div className={styles.item_title}>{t('settings.sharingContainer.items.shareChairLink')}</div>
          <SharingIcon
            onClick={() =>
              dispatch(
                modalActions.OPEN_MODAL.SUCCESS({
                  type: 'sharedWorkersModal',
                  callback: (value) => copyLinkToClickBoard(value),
                }),
              )
            }
          />
        </div>)}
      </div>
    </div>
  );
};

export default SharingContainer;
